import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["autoSize", "rows", "className", "strictMinHeight"];
import * as React from 'react';
import { composeRef } from "rc-util/es/ref"; // @ts-ignore

import AutoSize from 'autosize';
import classnames from 'classnames';
import { ConfigContext, SizeContext, LocaleContext } from '../ConfigProvider';
import InputBase from './InputBase';

var RefTextArea = function RefTextArea(props, ref) {
  var _React$useContext = React.useContext(ConfigContext),
      getPrettyCls = _React$useContext.getPrettyCls,
      getLocale = _React$useContext.getLocale;

  var contextSize = React.useContext(SizeContext);
  var contextLocale = React.useContext(LocaleContext);
  var localeMessages = getLocale(contextLocale, 'Input');

  var autoSize = props.autoSize,
      rows = props.rows,
      className = props.className,
      strictMinHeight = props.strictMinHeight,
      rest = _objectWithoutProperties(props, _excluded);

  var value = rest.value;
  var inputRef = React.useRef(null);
  var composedInputRef = composeRef(ref, inputRef);
  var prevValue = React.useRef();
  var bem = getPrettyCls('input-textarea-wrapper');
  var showCount = rest.showCount,
      showCountWhenFocused = rest.showCountWhenFocused;
  React.useEffect(function () {
    var _inputRef$current;

    var inputEle = (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.input;

    if (inputEle && autoSize) {
      AutoSize(inputEle);
    }

    return function () {
      if (inputEle && autoSize) {
        AutoSize.destroy(inputEle);
      }
    };
  }, [autoSize]);
  React.useEffect(function () {
    if (!prevValue.current && value) {
      var _inputRef$current2;

      var inputEle = (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.input;

      if (inputEle && autoSize) {
        AutoSize.update(inputEle);
      }
    }

    prevValue.current = value;
  }, [autoSize, value]);
  return /*#__PURE__*/React.createElement(InputBase, _objectSpread({
    className: classnames(bem({
      'strict-min-height': strictMinHeight
    }), className),
    element: "textarea",
    ref: composedInputRef,
    getPrettyCls: getPrettyCls,
    rows: rows,
    size: contextSize,
    placeholder: localeMessages.placeholder
  }, rest));
};

var TextArea = /*#__PURE__*/React.forwardRef(RefTextArea);
TextArea.defaultProps = {
  rows: 2,
  strictMinHeight: true
};
export default TextArea;